import { IconEye, IconEyeOff } from '@tabler/icons-react'

import { Button } from './Button'

type Props = {
	isValueVisible: boolean
	onClick: () => void
}

export const ButtonShow = ({ onClick, isValueVisible }: Props) => (
	<Button onClick={onClick}>{isValueVisible ? <IconEyeOff size={20} /> : <IconEye size={20} />}</Button>
)
